import type { ReachSDKConfig } from './types';

// assertions here are because we have tests guaranteering html structre.
export const messageElement = document.querySelector('[data-message]')!;

export function getMessageElement(): Element {
  return messageElement;
}

export function getSessionKeyFromUrl(): string {
  const params = new URLSearchParams(window.location.search);
  const sessionKey = params.get('session_key')?.trim();
  if (!sessionKey) {
    throw new Error('Missing session_key in URL');
  }
  return sessionKey;
}

export function getHintSDK() {
  return window.HintSDK;
}

export function initHintSDK(): void {
  window.HintSDK?.init();
}

export function getReachSDK() {
  return window.ReachSDK;
}

export function createReachSDK(config: ReachSDKConfig) {
  const SDK = getReachSDK();
  if (!SDK) {
    throw new Error('ReachSDK not loaded');
  }
  return new SDK(config);
}
